import textStyles from '@shared/ui/Typography/Text/Text.module.sass'
import IconDzen from '@icons/social-zn.svg'
import IconTelegram from '@icons/social-tg.svg'
import IconVK from '@icons/social-vk.svg'
import s from './NewsContent.module.sass'

const NewsSocial = () => (
  <div className={s.social}>
    <p className={`${textStyles.text} ${s['social-text']}`}>
      Скидки, подарки, акции и другие новости, которые приятно узнавать первыми, — в наших социальных сетях
    </p>

    <div className={s['social-list']}>
      <a href='https://t.me/afisharestaurants' className={s['social-link']} target='_blank' rel='noopener noreferrer'>
        <IconTelegram />
        Telegram канал Афиша Рестораны
      </a>

      <a href='https://vk.com/afisharestaurants' className={s['social-link']} target='_blank' rel='noopener noreferrer'>
        <IconVK />
        ВКонтакте группа Афиша Рестораны
      </a>

      <a href='https://dzen.ru/afisharests' className={s['social-link']} target='_blank' rel='noopener noreferrer'>
        <IconDzen />
        Яндекс.Дзен блог Афиша Рестораны
      </a>
    </div>
  </div>
)

export default NewsSocial
